import { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  TextField,
  Backdrop,
  makeStyles,
  CircularProgress
} from '@material-ui/core'
import { acceptOrder } from '../../api/orders.service'
import DeleteDialog from '../../components/DeleteDialog'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}))

const AcceptOrder = (params) => {
  const classes = useStyles
  const orderNumber = params.orderNumber
  const level = params.level
  const open = params.open
  const onSave = params.onSave
  const onCancel = params.onCancel

  const [stateForm, setStateForm] = useState({
    comment: ''
  })
  const [loading, setLoading] = useState(false)
  const [isMsgOpen, setisMsgOpen] = useState(false)

  const handleInputChange = (event) => {
    const value = event.target.value
    const name = event.target.name

    setStateForm({
      ...stateForm,
      [name]: value
    })
  }

  const handleAcceptOrder = async () => {
    const cleanStateForm = {
      ...stateForm,
      comment: stateForm.comment
        .replace(/[\r\n]+/g, ' ')
        .replace(/[\n]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    }

    const params = {
      orderNumber: orderNumber,
      level: level,
      ...cleanStateForm
    }
    setLoading(true)
    await acceptOrder(params)
      .then(() => {
        setisMsgOpen(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleCloseMsgModal = () => {
    setisMsgOpen(false)
    onSave()
    onCancel()
  }

  return (
    <div>
      <Dialog open={open}>
        <DialogContent>
          <Typography>
            {`¿Está seguro de que desea confirmar el pedido ${orderNumber}/${level}?`}
          </Typography>
          <TextField
            type="text"
            label="Comentario"
            placeholder="¿Tiene algún comentario para la compradora? "
            name="comment"
            fullWidth
            variant="outlined"
            className="mt-3"
            multiline
            rows={3}
            value={stateForm.comment}
            disabled={loading}
            onChange={handleInputChange}
          />
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} onClick={handleAcceptOrder} autoFocus color="secondary">
            Confirmar
          </Button>
          <Button disabled={loading} onClick={onCancel}>
            Cancelar
          </Button>
        </DialogActions>
        <Backdrop className={classes.backdrop} open={loading} onClick={onCancel}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
      <DeleteDialog
        text="Confirmación a Conway enviada correctamente. Se actualizará el estado del pedido en la próxima carga de datos."
        open={isMsgOpen}
        onYes={handleCloseMsgModal}
        yesLabel="Cerrar"
      ></DeleteDialog>
    </div>
  )
}

export default AcceptOrder
